
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-infographic.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-infographic-demo-infographic"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-infographic.en-US.md?type=demo')
};